import * as cx from 'classnames';
import * as React from 'react';
import * as Styles from './Price.scss';

interface IOwnProps {
  anyDiscount: boolean;
  quantity: number;
  priceEach: string;
  totalPrice: string;
  priceEachBeforeDiscount: string;
}

const Price: React.SFC<IOwnProps> = (props) => {
  const { quantity, totalPrice, priceEach, anyDiscount, priceEachBeforeDiscount } = props;

  const priceEachClassNames = cx({
    [Styles.value]: true,
    [Styles.discounted]: anyDiscount,
  });

  const priceTotalClassNames = cx({
    [Styles.total]: quantity > 1,
    [Styles.value]: quantity === 1,
    [Styles.discounted]: anyDiscount,
  });

  return (
    <div className={Styles.price}>
      {anyDiscount && <div className={Styles.beforeDiscount}>{priceEachBeforeDiscount}</div>}
      {quantity > 1 && (
        <div>
          <span className={Styles.quantity}>{`${quantity}×`}</span>
          <span className={priceEachClassNames}>{priceEach}</span>
        </div>
      )}
      <span className={priceTotalClassNames}>{totalPrice}</span>
    </div>
  );
};

export default Price;
